import Vue from 'vue';
import moment from 'moment';


export default {
  name: 'Disconnection',
  props: ['dataObj'],
  data: function () {
    return {
      appData: {
        account: '',
        caseId: 0,
        connectionId: 0,
        finalReading: 0,
        finalReadingDate: new Date(),
        finalReadingDateAux: new Date(),
        finalReadingClockOver: false,
        isUnderInvestigation: false,
        comment: '',
        readonly: false,
        bIsDateSet: false
      },
      showDate: { finalReadingDate: false, finalReadingDateAux: false },
      finalReadingDate: {},
      finalReadingDateAux: {},
      disabledDates: date => { return moment(date).isSameOrAfter(moment()); },
    }
  },
  created() {
    this.init();
    this.$root.$on('disconnection_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.dataObj;
        this.appData.bIsDateSet = false;
      });
    },
  },
}
